import script from "./index.web.vue?vue&type=script&setup=true&lang=js"
export * from "./index.web.vue?vue&type=script&setup=true&lang=js"

import "./index.web.vue?vue&type=style&index=0&id=5635bc7d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5635bc7d"]])

export default __exports__